<div class="flex items-center gap-x-3 pointer-events-auto">

    <!-- Logo and client name only outside iframe mode; iframe shows the venue name alone -->
    @if (!iframeMode) {
        <div class="shrink-0">
            <app-logo/>
        </div>
    }

    <div class="flex flex-row items-center gap-x-2 leading-tight">

        @if (!iframeMode && clientName()) {
            <span class="hidden md:block font-bold text-sm uppercase tracking-wide text-center">{{ clientName() }}</span>
        }

        @if (!iframeMode && venueName()) {
            <span class="block border-l border-current/20 h-8 self-center"></span>
        }

        <!-- Venue name: bigger in iframe mode; color inherited from topbar mode -->
        @if (venueName()) {
            <span class="font-bold uppercase tracking-wider" [class]="iframeMode ? 'text-base' : 'text-sm md:text-xs md:font-normal'">{{ venueName() }}</span>
        }

    </div>

</div>
